import React, { useCallback } from 'react';
import { ArrowIcon, RegularButton } from 'fronton-react';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { QtyCounter } from 'common/components/qty-counter';
import { addToBasketSticky } from 'common/components/product-price-view/sticky.styles';
import { analyticsUtils, patchUrlByLocale } from 'utils';
import { counterWrapper, toBasket } from './styles';
import { ButtonWithCounterProps } from './types';

export const DATA_QA_TO_BASKET_BUTTON = 'to-basket-button';

export const ButtonWithCounter: React.FC<ButtonWithCounterProps> = ({
  onBasketChange,
  onBasketRemove,
  classnameCounter = '',
  productId,
  quantity,
  measurementSettings,
  mainUom,
  isSwapPrice,
  secondPrice,
  size = 'l',
  isStickyPanel,
}) => {
  const { t } = useTranslation();

  const toBasketClickHandler = useCallback(() => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementBlock: 'productDetail',
      elementName: 'toBasket',
      elementText: 'Перейти в корзину',
      elementType: 'button',
    });
  }, []);

  const uom = isSwapPrice ? secondPrice?.unit : mainUom;

  const changeHandler = useCallback(
    (value: number) => {
      const flowQty = value - quantity;
      if (flowQty !== 0) {
        onBasketChange(productId, flowQty);
      }
    },
    [productId, onBasketChange, quantity],
  );

  return (
    <div className={counterWrapper}>
      <QtyCounter
        step={measurementSettings?.step}
        min={measurementSettings?.step}
        overriddenValue={quantity}
        className={classnameCounter}
        isStickyPanel={isStickyPanel}
        uom={uom}
        onChange={(val: number) => changeHandler(val)}
        onRemove={() => onBasketRemove(productId)}
      />
      {!isStickyPanel && (
        <RegularButton
          className={isStickyPanel ? cx(toBasket, addToBasketSticky) : toBasket}
          iconOnly
          data-qa={DATA_QA_TO_BASKET_BUTTON}
          size={size}
          label={t('product-info.add-to-basket.aria-label.go-to-cart')}
          onClick={toBasketClickHandler}
          href={patchUrlByLocale('/basket/')}
        >
          <ArrowIcon direction="right" />
        </RegularButton>
      )}
    </div>
  );
};
